import axios from 'axios';
import { getCookie, setCookie, removeCookie } from './cookieUtils';

const API_URL = process.env.REACT_APP_API_URL;

// Create axios instance with credentials
const api = axios.create({
  baseURL: API_URL,
  withCredentials: true, // Include cookies in requests
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('authToken') || getCookie('auth-token');
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    const csrfToken = getCookie('csrf-token');
    if (csrfToken) {
      config.headers['X-CSRF-Token'] = csrfToken;
    }
    
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      
      try {
        const response = await axios.get(`${API_URL}/api/auth/refresh`, {
          withCredentials: true,
        });
        
        if (response.status === 200 && response.data.token) {
          const { token } = response.data;
          sessionStorage.setItem('authToken', token);
          
          originalRequest.headers.Authorization = `Bearer ${token}`;
          
          return api(originalRequest);
        }
      } catch (refreshError) {
        sessionStorage.removeItem('authToken');
        removeCookie('auth-token');
        
        if (window.location.pathname !== '/' && 
            window.location.pathname !== '/auth/callback' &&
            window.location.pathname !== '/subscription-required') {
          window.location.href = '/';
        }
      }
    }
    
    if (error.response?.status === 403) {
      const isSubscriptionRequired = 
        error.response.data?.code === 'SUBSCRIPTION_REQUIRED' || 
        error.response.data?.message?.includes('Patreon supporter');
      
      if (isSubscriptionRequired) {
        if (window.location.pathname !== '/subscription-required') {
          console.log('Redirecting to subscription-required page due to 403 Patreon error');
          window.location.replace('/subscription-required');
          return Promise.resolve({ data: { redirected: true } });
        }
      }
    }
    
    return Promise.reject(error);
  }
);

export default api; 